export default __webpack_public_path__ + "static/media/switzerland.1152e711.svg";